import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "iframe-wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "video-content"
}
const _hoisted_3 = ["innerHTML"]

import { computed, onMounted } from "vue";
import { IonSkeletonText } from "@ionic/vue";
import AlternativeActivity from "@/components/Common/AlternativeActivity/AlternativeActivity.vue";
import { useSanityStore } from "@/store";
import { SanityBlocks } from "sanity-blocks-vue-component";
import { useI18n } from "vue-i18n";

interface Props {
  _ref: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'VideoSerializer',
  props: {
    _ref: {}
  },
  setup(__props: any) {

const { t } = useI18n<{}>({
  useScope: "global",
});

const sanityStore = useSanityStore();

const props = __props;

const isLoading = computed(() => {
  return sanityStore.getLoadingFor(props._ref);
});

const document = computed(() => {
  // Using type any here until a type for a Sanity Video is deinfed and the SanityStore is migrated to composition API and typescript
  return sanityStore.getDocument(props._ref) as any;
});

onMounted(async () => {
  await sanityStore.requestDocument(props._ref);
});

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonSkeletonText), { animated: true })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "iframe-wrapper",
          innerHTML: document.value?.embedlink
        }, null, 8, _hoisted_3),
        _createVNode(AlternativeActivity, {
          id: "alternative-activity",
          show: !!document.value?.transcript,
          labelExpanded: _unref(t)('resource.video.transcriptExpanded'),
          labelCollapsed: _unref(t)('resource.video.transcriptCollapsed')
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SanityBlocks), {
              blocks: document.value?.transcript
            }, null, 8, ["blocks"])
          ]),
          _: 1
        }, 8, ["show", "labelExpanded", "labelCollapsed"])
      ]))
}
}

})